import React, { useEffect, useState } from 'react';
import ModalDialog from '@ui/modal/ModalDialog';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import analytics from '@utils/analytics';
import SubscribeForm from './SubscribeForm';
const StandaloneSubscribeOverlay = (props) => {
    const { t } = useTranslation();
    const { eventName } = props;
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        window.addEventListener(eventName, activateComponent);
        return () => {
            window.removeEventListener(eventName, activateComponent);
        };
    }, []);
    const activateComponent = () => {
        setIsOpen(true);
    };
    return (React.createElement(ModalDialog, { overlayClassName: "overlay-visible", className: classNames('subscribe-overlay', { black: props.blackVersion }), hideHeader: true, noPadding: true, 
        // isOpen={isOpen && formdef != undefined}
        isOpen: isOpen, onRequestClose: () => {
            analytics.getNotificationModalAction(props.type, props.title, 'close');
            setIsOpen(false);
        }, contentLabel: t('label.notifyme') },
        React.createElement(SubscribeForm, Object.assign({}, props, { closeCallback: () => setIsOpen(false) }))));
};
export default StandaloneSubscribeOverlay;
